import { Box, Typography, IconButton } from "@mui/material";
import { Header } from "./Header";
import { useState, useEffect } from "react";
import { Products } from "./Products";
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import ShoppingCartCheckoutOutlinedIcon from '@mui/icons-material/ShoppingCartCheckoutOutlined';
import { Setup } from "./Setup";
import { CstmSnackBar } from "../../../../../../core/global/forms/CstmSnackBar";
import { Summary } from "./Summary";
import { WaveIcons } from "../../../../../../core/global/Icons";
import { History as HistoryIcon, QrCodeScanner } from '@mui/icons-material';
import { History } from "./History";
import { FirstPurchaseModal, ReadyForBusinessModal } from "./Modal";
import { domain, env } from "../../../../../../core/Env";
import BarcodeScanner from "../../../BarcodeScanner";

export const Index = () => {
    const [info, setInfo] = useState({ branch_name: "" });
    const [products, setProducts] = useState([]);
    const [orderList, setOrderList] = useState([]);
    const [snackBarLoader, setSnackBarLoader] = useState({ snackbar: false, msg: '', type: '' });
    const [order, setOrder] = useState([]);
    const [open, setOpen] = useState(false);
    const [modal, setModal] = useState(true);
    const [orderCounter, setOrderCounter] = useState(0);
    const [historyModal, setHistoryModal] = useState(false);
    const [checkoutModal, setCheckoutModal] = useState(false);
    const [firstPurchaseModal, setFirstPurchaseModal] = useState(false);
    const [readyForBusinessModal, setReadyForBusinessModal] = useState(false);
    const [scanModal, setScanModal] = useState(false); // Scanner toggle state

    const currentDayStatus = () => {
        const hours = new Date().getHours();
        return hours < 12 ? 'Morning' : hours < 18 ? 'Afternoon' : 'Evening';
    };

    const handleBarcodeScan = (barcode) => {
        const product = products.find(p => p.barcode === barcode || p.id === barcode);
        if (product) {
            setOrderList(prev => {
                const existing = prev.find(item => item.barcode === product.barcode);
                if (existing) return prev.map(item => item.barcode === product.barcode ? { ...item, value: item.value + 1 } : item);
                return [...prev, { ...product, value: 1 }];
            });
            setSnackBarLoader({ snackbar: true, msg: `Added ${product.name}`, type: 'success' });
        } else {
            setSnackBarLoader({ snackbar: true, msg: 'Product not found', type: 'error' });
        }
    };

    useEffect(() => {
        if (orderCounter === 1) setFirstPurchaseModal(true);
        else if (orderCounter % 5 === 0 && orderCounter !== 0) setReadyForBusinessModal(true);
    }, [orderCounter]);

    useEffect(() => {
        if (products.length % 5 === 0 && products.length !== 0) setReadyForBusinessModal(true);
    }, [products]);

    const tool_id = process.env.REACT_APP_TID_BIZ;
    const regHandler = () => {
        let subscription = (env() === 'dev' ? 'c3Vic2NyaXB0aW9uXzY5NQ==' : (env() === 'sb' ? 'c3Vic2NyaXB0aW9uXzQ2NQ==' : 'c3Vic2NyaXB0aW9uXzM2NA=='));
        window.location.href = `${domain('mp').url}/subscription/checkout/rqx?tid=${window.btoa(`tool_${tool_id}`)}&callback=${env()}&platform=business&subscription=${subscription}&ref=unauth&auth_type=registration`;
    };

    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "space-between", flexDirection: "column", height: "100%", bgcolor: "primary.main" }}>
                <Header regHandler={regHandler} />
                <Box sx={{ height: "90%", p: 2, bgcolor: "#fff", borderTopLeftRadius: 16, borderTopRightRadius: 16 }}>
                    <Box height="92%" width="100%" display="flex" flexDirection="column" gap="12px">
                        <Box minHeight="20px" display="flex" alignItems="center" justifyContent="space-between">
                            <Box display="flex" alignItems="center" gap="12px">
                                <Box fontSize="14px" color="#283745">Extraordinary {currentDayStatus()},</Box>
                                <Box fontWeight={400}>Hero</Box>
                                <WaveIcons fill='#FFCB22' />
                            </Box>
                            {/* Barcode Button */}
                            <IconButton onClick={() => setScanModal(true)} sx={{ bgcolor: 'primary.light', color: 'primary.main' }}>
                                <QrCodeScanner />
                            </IconButton>
                        </Box>

                        <Box>
                            <Box minHeight="10px" width="100%" display="flex" justifyContent="space-between" alignItems="center" gap="12px">
                                <Box width="100%" fontWeight={700}>My Store</Box>
                                <Box onClick={() => { setHistoryModal(true) }} sx={{ color: '#11783C', width: "100%", cursor: 'pointer' }}>
                                    <Box display="flex" alignItems="center" gap="2px" >
                                        <HistoryIcon sx={{ height: '18px' }} />
                                        <Box fontSize={12}>View Last Transaction</Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                        
                        {products.length > 0 ?
                            <Box sx={{ py: 1, px: 2, height: "100%", overflowY: "auto" }}>
                                <Products products={products} setOrderList={setOrderList} orderList={orderList} />
                            </Box>
                            :
                            <Box width="100%" height="100%" display="flex" justifyContent="center" alignItems="center" onClick={() => { setModal(true) }}>
                                <Box textAlign="center">
                                    <AddBusinessIcon sx={{ color: "primary.main", fontSize: 40 }} />
                                    <Box color="#011104" fontSize={14} >Set up your shop in 30 seconds</Box>
                                </Box>
                            </Box>
                        }
                    </Box>

                    <Box sx={{ display: "flex", gap: 1, width: '100%', justifyContent: "flex-end", bgcolor: "#fff" }}>
                        {orderList.length > 0 &&
                            <Box sx={{ p: 2, width: "100%", bgcolor: "primary.main", borderRadius: 3, display: "flex", justifyContent: "center", alignItems: "center", cursor: 'pointer' }} onClick={() => { setCheckoutModal(true) }}>
                                <ShoppingCartCheckoutOutlinedIcon sx={{ color: "#fff" }} />
                                <Typography color="#fff">Checkout</Typography>
                            </Box>
                        }
                        <Box sx={{ bgcolor: "#0e683cff", px: 2, color: "#ffffffff", border: 2, borderRadius: 3, fontSize: "40px", alignItems: "center", cursor: 'pointer' }} onClick={() => { setModal(true) }}>+</Box>
                    </Box>
                </Box>

                <Setup modal={modal} setModal={setModal} open={open} setOpen={setOpen} snackBarLoader={snackBarLoader} setSnackBarLoader={setSnackBarLoader} products={products} setProducts={setProducts} setInfo={setInfo} info={info} />
                {snackBarLoader.snackbar && (
                    <CstmSnackBar value={snackBarLoader} setter={setSnackBarLoader} msg={snackBarLoader.msg} type={snackBarLoader.type} />
                )}
                <Summary checkoutModal={checkoutModal} setCheckoutModal={setCheckoutModal} setOrderCounter={setOrderCounter} orderCounter={orderCounter} orderList={orderList} setOrderList={setOrderList} setOrder={setOrder} snackBarLoader={snackBarLoader} setSnackBarLoader={setSnackBarLoader} />
                <History historyModal={historyModal} order={order} setHistoryModal={setHistoryModal} />
                
                {/* Barcode Scanner Component */}
                <BarcodeScanner 
                    open={scanModal} 
                    onClose={() => setScanModal(false)} 
                    onScan={handleBarcodeScan} 
                />
            </Box>

            <FirstPurchaseModal open={firstPurchaseModal} close={() => { setFirstPurchaseModal(false) }} order={order} register={regHandler} />
            <ReadyForBusinessModal open={readyForBusinessModal} close={() => { setReadyForBusinessModal(false) }} register={regHandler} />
        </>
    )
}